import { articles } from "@/mocks/content";
import SectionHeading from "./SectionHeading";

export default function Articles() {
  return (
    <section id="articles" className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <SectionHeading
          eyebrow="专题解读"
          title="漫画深度专题"
          subtitle="编辑团队撰写的深度文章，解读高分漫画背后的故事内核、类型趋势与宝藏挖掘，帮你看得更深、选得更准。"
        />
        <a
          href="#articles"
          className="mb-10 inline-flex items-center gap-1 whitespace-nowrap text-sm text-primary-600 hover:text-primary-700"
        >
          查看全部专题
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </a>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {articles.map((article) => (
          <a
            key={article.id}
            href="#articles"
            className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
          >
            <div className="relative aspect-[8/5] w-full overflow-hidden bg-background-100">
              <img
                src={article.image}
                alt={`${article.title}专题配图`}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-medium text-white">
                {article.tag}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-4 md:p-5">
              <h3 className="font-heading text-base leading-snug text-foreground-950 group-hover:text-primary-600">
                {article.title}
              </h3>
              <p className="mt-2 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-600">
                {article.excerpt}
              </p>
              <div className="mt-4 flex items-center gap-3 border-t border-background-200 pt-3 text-xs text-foreground-400">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-calendar-line" aria-hidden="true"></i>
                  {article.date}
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-time-line" aria-hidden="true"></i>
                  {article.read}
                </span>
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}